// Brand lockup: gold DK monogram + typographic wordmark matching the official logo (works on light and dark surfaces).
export const BrandLockup = ({ tone = "light", size = "md", className = "" }) => {
  const dark = tone === "dark";
  const s = { sm: ["w-9 h-9", "text-sm", "text-[7px]"], md: ["w-11 h-11 md:w-12 md:h-12", "text-base md:text-lg", "text-[8px]"], lg: ["w-16 h-16", "text-2xl", "text-[10px]"] }[size];
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img src="/dk-logo.png" alt="Dutsen Kauna Foundation monogram" className={`${s[0]} object-contain shrink-0`} />
      <span className="leading-none">
        <span className={`block font-serif font-bold tracking-tight whitespace-nowrap ${s[1]} ${dark ? "text-white" : "text-[#0d1724]"}`}>Dutsen Kauna</span>
        <span className={`block uppercase tracking-[0.32em] font-semibold mt-1 ${s[2]} ${dark ? "text-[#d6aa43]" : "text-[#7a5a0f]"}`}>— Foundation —</span>
      </span>
    </span>
  );
};
